module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || '65p2a0lf',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
